export default __webpack_public_path__ + "static/banner4-4551e3e165edfecad741303bcef90200.png";